module.exports = __webpack_public_path__ + "img/twitter-white.3eb64e7c.svg";